// extracted by mini-css-extract-plugin
module.exports = {"bgVideo":"BackgroundVideo_bgVideo__cRh_v","fill":"BackgroundVideo_fill__1141O","poster":"BackgroundVideo_poster__1Ph2Y"};